
export enum DirectSalesListingSnapshotWsEventResponseDtoEvent {
  DirectSalesListingSnapshot= 'DirectSalesListingSnapshot',

}